// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__x3nhO","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1DLHI"};